export enum TicketUrgency {    
    NotUrgent = 0,
    Urgent = 10
}